<div class="cpp-content-sales"> 
  <div class="cpp-heading">
    <div class="cpp-heading__content">
      <span class="cpp-heading__title">{{ labels['sales.title'] }}</span>
    </div>
  </div>

  <p>{{ labels['sales.description'] }}</p>

  <div class="spotlight">
    <a class="cpp-button cpp-button--lg cpp-button--happy"
      target="sales"
      [href]="redirectUrl">
      <button class="cpp-button-access-platform"><b>{{ labels['sales.button'] }}</b></button>
    </a>
  </div>
  <div class="banner-image">
  </div>
</div>